import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'
import { setReferer } from '@/common/utils/referer'

export default [
  {
    path: '/player/stream/:section',
    name: PATH_NAME_PLAYER_STREAM,
    components: {
      // TODO:: 이거 동적로드가 필요한가?
      player: () => import(/* webpackChunkName: "player_stream" */'@/pages/player/stream')
    },
    beforeEnter: (to, from, next) => {
      if (from.name !== 'login' && from.name !== 'profile_list') {
        setReferer(from.fullPath)
      }
      next()
    }
  }
]
